import { render, staticRenderFns } from "./ShipmentData.vue?vue&type=template&id=479faaa2&scoped=true&"
import script from "./ShipmentData.vue?vue&type=script&lang=js&"
export * from "./ShipmentData.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentData.vue?vue&type=style&index=0&id=479faaa2&lang=scss&scoped=true&"
import style1 from "./ShipmentData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479faaa2",
  null
  
)

export default component.exports